import Cookies from 'js-cookie';
import { Provider } from 'mobx-react';
import App from "next/app";
import Head from 'next/head';
import Router from 'next/router';
import NProgress from 'nprogress';
import React from "react";
import { fetchBookmarkSync, fetchFollowSync, fetchLikeSync, fetchVoteSync } from '../components/fetchData';
import AdsFreqCap from '../components/mobile/ads/adsFreqCap';
import { A2hs } from "../components/mobile/mobile_a2hs";
import initializeStore from '../store/stores';
import handshake from '../utils/handshake';
import { deviceDetect } from '../utils/instrumentation_josh/handleClientRegistration';
import UserSession from '../utils/instrumentation_josh/sessionManger';
import { isTimeStampElapsed, manageBookmarkStatus, manageFollowStatus, manageLikeStatus, manageUser, manageVoteStatus } from '../utils/joshCommonUtil';

Router.events.on('routeChangeStart', () => NProgress.start());
Router.events.on('routeChangeComplete', () => NProgress.done());
Router.events.on('routeChangeError', () => NProgress.done());

class WildApp extends App {
  static async getInitialProps({ Component, ctx }) {
    const mobxStore = initializeStore();
    ctx.mobxStore = mobxStore;
    let pageProps = {};


    if (Component.getInitialProps) {
      pageProps = await Component.getInitialProps(ctx);
    }

    return { pageProps, initialMobxState: mobxStore, };
  }

  constructor(props) {
    super(props);
    this.state = {
      displayClientComp: false,
      registerSW: false
    }
    const isServer = typeof window === 'undefined';
    this.mobxStore = isServer ? props.initialMobxState : initializeStore(props.initialMobxState);
  }

  handleLandscapeMode() {
    if (window.orientation == 90 || window.orientation == -90) {
      setTimeout(() => {
        document.getElementById('__next').style.display = "none";
        console.log("Landscape Mode Not supported");
        let orientation_change = document.getElementById('orientation_change');
        document.getElementById('offSubTitle').innerHTML = "Landscape Mode Not Supported. Please try Portrate Mode";
        orientation_change.style.display = "block";
      }, 0)
    }
  }

  componentDidMount() {
    this.handleLandscapeMode();
    Router.beforePopState(({ as }) => {
      location.href = as;
    });

   // this.setState({ registerSW: true })
    let client_id = Cookies.get('__joshclientId__');
    let session = new UserSession(client_id);
    const userAgentOnMount = navigator.userAgent;
    const deviceDetailOnMount = userAgentOnMount && deviceDetect(userAgentOnMount);
    const deviceTypeOnMount = deviceDetailOnMount && deviceDetailOnMount.device && deviceDetailOnMount.device.type || 'desktop';
    const pathname = this.props && this.props.router && this.props.router.pathname;
    const isWebview = (pathname && pathname.split('/').length > 2) && pathname != '/404';
    if ((!isWebview) && deviceTypeOnMount != 'desktop') {
      this.handleFirstLoad(deviceTypeOnMount);
    }
    if (!isWebview) {
      this.setState({ registerSW: true })
    }
  }

  handleFirstLoad = (deviceTypeOnMount) => {
    this.setState({
      displayClientComp: (deviceTypeOnMount != 'desktop'),
    })
    handshake('en', {}, 'INIT').then(res => console.log("Handshake success!!"));
    // Cleanup frequency cap
    const fc = new AdsFreqCap();
    fc.fcCleanup();

    const lastSyncTimestamp = localStorage && localStorage.getItem('lastSyncTimestamp');
    const shouldSync = lastSyncTimestamp ? isTimeStampElapsed(lastSyncTimestamp, 1 * 60) : true; // 3Min
    const isLoggedIn = manageUser.getUserUUID();
    if (shouldSync && isLoggedIn != null) {
      localStorage.setItem('lastSyncTimestamp', Date.now());
      fetchFollowSync().then(resp => {
        if (resp && resp.status && resp.status.code == 200) {
          manageFollowStatus.set(resp.data);
        }
      })

      fetchLikeSync().then(response => {
        if (response && response.status && response.status.code == 200) {
          manageLikeStatus.set(response.data);
        }
      })

      fetchVoteSync().then(response => {
        if (response && response.status && response.status.code == 200) {
          const votes = response && response.data && response.data.content_ids || [];
          manageVoteStatus.set(votes);
        }
      })

      fetchBookmarkSync().then(response => {
        if (response && response.status && response.status.code == 200) {
          const bookmarks = response && response.data && response.data.rows || [];
          manageBookmarkStatus.set(bookmarks);
        }
      })
    }
  }

  render() {
    const { Component, pageProps } = this.props;
    //  console.log('{{_app.js}}',this.props)
    return (
      <Provider {...this.mobxStore}>
        <React.Fragment>
          <Head>
            <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0" />
          </Head>
          <Component {...pageProps} />
          <a role="button" aria-label='top btn' id="top" onClick={(e) => { document.body.scrollTop = 0; document.documentElement.scrollTop = 0; }} className="backtotop" title="Top"></a>
          {this.state.registerSW && <A2hs displayClientComp={this.state.displayClientComp} />}
        </React.Fragment>
      </Provider>
    );
  }
}

export default WildApp;
